$('[data-rol="dropdown-menu"]').on('click', function() {
	$('.blog-menu__list').slideToggle(300);
});

// при загрузке страницы вставляем в title списка первый элемент

if ($(window).width() < 768) {

	$(window).on('load', function() {
		var firstItem = $('[data-rol="dropdown-menu"]').siblings('.blog-menu__list').children()[0];
		var firstItemHtml = $(firstItem).html();
		$('[data-rol="dropdown-menu"]').html(firstItemHtml);
		$(firstItem).addClass('hidden');
	});

	// при нажатии на пукт меню перемещаем выбраный html в title и удаляем его; снимаем hidden с предыдущих невидимых и скрываем меню

	$('.blog-menu__item').on('click', function(e) {

		if($(this).hasClass('hidden')) {
			return;
		}

		var thisHtml = $(this).html();
		$('[data-rol="dropdown-menu"]').html(thisHtml);
		$(this).addClass('hidden');
		$(this).siblings().removeClass('hidden');
		$('.blog-menu__list').slideUp(300);
	})
} else {
	$('.blog-menu__item').on('click', function(e) {
		e.preventDefault();

		$(this).toggleClass('active');
		$(this).siblings().removeClass('active');
	});
}



